import { defineStore } from "pinia";
import { computed, ref } from "vue";
import useMyFetch from "@stores/useMyFetch";
import { deepCopy, isEmpty } from "@utils/toolBox";
import { captureEvent } from "@/lib/analytics";

export const useSurveyLearningsStore = defineStore("surveyLearnings", () => {
  const learnings = ref({});
  const initialLearnings = ref({});

  async function fetchLearnings(token) {
    const { data, response } = await useMyFetch(`surveys/${token}/learnings`).json();

    if (response.value.ok) {
      learnings.value = data.value;
      initialLearnings.value = deepCopy(data.value);
    }
    return learnings.value;
  }

  //check if changes have been made to enable save button
  const hasLearningsChanged = computed(() => {
    if (isEmpty(learnings.value) || isEmpty(initialLearnings.value)) return false;
    return JSON.stringify(learnings.value) !== JSON.stringify(initialLearnings.value);
  });

  async function saveLearnings(token) {
    const { data, response } = await useMyFetch(`surveys/${token}/learnings`)
      .put({
        learnings_costs: learnings.value.learnings_costs,
        learnings_issues: learnings.value.learnings_issues,
        learnings_comments: learnings.value.learnings_comments,
      })
      .json();
    if (response.value.ok) {
      initialLearnings.value = deepCopy(data.value);
      captureEvent("survey_learnings_saved");
    }
  }

  return {
    //State
    learnings,
    initialLearnings,
    //actions
    fetchLearnings,
    saveLearnings,
    //getters
    hasLearningsChanged,
  };
});
